import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";
import vectorIcon from "./../../../../assets/_VectorIcon_.svg";
import { FormGroup } from "../components/FormGroup";
import { IGroupForm } from "../../../../@types/group.type";
import { DefaultList } from "../components/DefaultList";
import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface GroupProps {
  pageType: "create" | "update";
  groupData?: IGroupForm | null;
}

export const Permission: React.FC<GroupProps> = ({
  pageType,
  groupData,
}) => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <>
      <div className={styles.group}>
        <div className={styles.back}>
          <Button className={styles.button} onClick={() => navigate("/configurations/permissions/")}>
            {vectorIcon && <img src={vectorIcon}/>}
            Voltar a tela anterior
          </Button>
        </div>
        <div className={styles.title}>
          <h1>
          {pageType === "update" && groupData && typeof groupData !== "string"
            ? groupData.groupName
            : "Novo Grupo"}
          </h1>
        </div>
        <div>
        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" classes={{
                  indicator: styles['MuiTabs-indicator'],
              }}>
              <Tab label="Permissões" {...a11yProps(0)} className={styles.tab}/>
              {pageType === "update" && (
                <Tab label="Membros" {...a11yProps(1)} className={styles.tab}/>
                )}
            </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <FormGroup
            pageType={pageType}
            groupData={groupData || undefined}
          />
        </CustomTabPanel>
        {pageType === "update" && (
            <CustomTabPanel value={value} index={1}>
                <DefaultList 
                    groupId={groupData?.groupId || ""}
                />
            </CustomTabPanel>
            )}
        
        </div>
      </div>
    </>
  );
};
